{
  "listingTableConfig": {
    "name": "Customer Agreement",
    "columns": [
      {
        "fieldName": "contractNumber",
        "displayName": "Agreement Number",
        "dataType": "CLICKABLE",
        "styleConfig": {
          "type": "hyper-link"
        }
      },
      {
        "fieldName": "accountHolder.name",
        "displayName": "Account Holder",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "250px"
        }
      },
      {
        "fieldName": "active",
        "displayName": "Status",
        "dataType": "STRING",
        "valueMap": {
          "true": "Active",
          "false": "Inactive"
        },
        "thStyleConfig": {
          "width": "60px"
        },
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "cycle",
        "displayName": "Cycle",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "100px"
        }
      },
      {
        "fieldName": "fromDate",
        "displayName": "From",
        "dataType": "DATETIME",
        "thStyleConfig": {
          "width": "100px"
        }
      },
      {
        "fieldName": "toDate",
        "displayName": "To",
        "dataType": "DATETIME",
        "thStyleConfig": {
          "width": "100px"
        }
      },
      {
        "fieldName": "description",
        "displayName": "Description",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "335px"
        }
      },
      {
        "fieldName": "modifiedBy",
        "dbName": "modified_by",
        "displayName": "Modified By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedDate",
        "dbName": "modified_date",
        "displayName": "Modified Date",
        "dataType": "DATETIME",
        "sortable": true
      }
    ],
    "actions": [
      {
        "fieldName": "fileUploads",
        "displayName": "",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "120px"
        },
        "styleConfig": {
          "type": "action",
          "icon": "assets/icons/download_icon.svg",
          "iconStyleProperties": {
            "background": "var(--brand-600)"
          },
          "styleProperties": {
            "display": "flex",
            "gap": "4px",
            "alignItems": "center",
            "background": "transparent",
            "color": "#1062B9",
            "fontSize": "14px",
            "fontStyle": "normal",
            "border": "none",
            "fontWeight": 500,
            "lineHeight": "20px"
          },
          "actionConfig": {
            "label": "Attachments",
            "actionName": "download-attachments",
            "writeOperation": false,
            "conditions": [
              {
                "expression": "gt(value.length, 0)"
              }
            ]
          }
        }
      }
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "contract_number",
        "displayLabel": "Contract Number",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "EQ": "CONTRACT_NO_EQUALS",
          "CONTAINS": "CONTRACT_NO_CONTAINS"
        }
      },
      {
        "name": "accountHolder",
        "displayLabel": "Account Holder",
        "dataType": "STRING",
        "supportedOperators": ["EQ"],
        "operatorToFilterMap": {
          "EQ": "ACCOUNT_HOLDER_EQUALS"
        },
        "hasLookup": true,
        "searchConfig": {
          "apiUrl": "v1/customers/list",
          "filterByKeys": ["NAME_CONTAINS"],
          "additionalFilters": [
            {
              "name": "IS_ACTIVE",
              "alias": "active",
              "operator": "EQ",
              "value": ["true"]
            }
          ],
          "limit": 10,
          "orderBy": { "name": "asc" },
          "bindLabel": "name",
          "bindValue": "id",
          "displayColumns": [{ "key": "name", "header": "Name" }]
        }
      },
      {
        "name": "isActive",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "ACTIVE_EQUALS"
        }
      },
      {
        "name": "cycle",
        "displayLabel": "Cycle",
        "dataType": "PICKLIST",
        "options": [{
          "label": "Import",
          "value": "IMPORT"
        },
        {
          "label": "Export",
          "value": "EXPORT"
        },
        {
          "label": "Empty",
          "value": "EMPTY"
        },
          {
            "label": "Bond",
            "value": "BOND"
          }
        ],
        "operatorToFilterMap": {
          "IN": "CYCLE_CONTAINS"
        }
      },
      {
        "name": "fromDate",
        "displayLabel": "From Date",
        "dataType": "DATE",
        "operatorToFilterMap": {
          "GT": "AGREEMENT_FROM_DATE_GT",
          "LT": "AGREEMENT_FROM_DATE_LT"
        }
      },
      {
        "name": "toDate",
        "displayLabel": "To Date",
        "dataType": "DATE",
        "operatorToFilterMap": {
          "GT": "AGREEMENT_TO_DATE_GT",
          "LT": "AGREEMENT_TO_DATE_LT"
        }
      }
    ],
    "useNewContract": true
  }
}
